<template>
  <div class="eventComp">
    <nav-local-comp :all="'Акции'" :id="id" :toAll="toAll"/>
    <tabs-comp :moduleName="moduleName"/>
    <!-- <ticket-one-comp v-if="tabs.ticket.active"/> -->
    <event-crud-comp v-if="tabs.crud.active"/>
    <!-- <event-users-comp v-if="tabs.users.active"/> -->
    <users-comp
        v-if="tabs.users.active"
        :onFilter="true"
        :required="[
        'userEvents',
        'id',
        'phone',
        'repost',
        'bonus',
        'sale',
        'bonusDate',
        'group',
        'ordersCount',
        'ordersBonus',
        'ordersPrice'
      ]"
        :eventId="Number(id)"
    />
    <groups-comp
        v-if="tabs.groups.active"
        :required="['groupEvents', 'id', 'createdAt', 'name', 'promocode', 'sale', 'dealerIdMysql', 'dealerName', 'usersCount', 'ordersCount', 'ordersPrice', 'ordersBonus']"
        :eventId="Number(id)"
    />
    <!-- <user-one-comp v-if="tabs.user.active" :params="{id: userId}"/> -->
    <!-- <tbl-many-comp v-if="tabs.problems.active" :data="dataProblems" :model="modelProblems"/> -->
    <!-- <gallery-comp v-if="tabs.images.active" :images="images"/> -->
  </div>
</template>

<script>
export default {
  name: 'eventComp',
  props: {},
  data: function () {
    return {
      moduleName: 'events',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    },
    tabs: function () {
      return this.$store.getters[`${this.moduleName}/getTabs`]
    },
    userId: function () {
      return this.$store.getters[`${this.moduleName}/getUserId`]
    },
    modelProblems: function () {
      let model = this.$store.getters['problems/getModel']
      return this.$helpers.mapper.modelRequired(['id', 'name', 'comment'], model)
    },
    dataProblems: function () {
      let ticket = this.$store.getters[`${this.moduleName}/getOne`]
      return ticket.problems.value
    },
    images: function () {
      let ticket = this.$store.getters[`${this.moduleName}/getOne`]
      return ticket.images.value
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
